export default "__VITE_ASSET__CikpAyDb__"